import React from 'react'
import './DataTableStyles.css'

function TestComp(props) {
  // Destructure only one necessary prop for now, or none
  const { title = "Default Title" } = props;

  console.log('Minimal DataTable rendered');

  // Extremely simple return
  return (
    <div className="reactUiDataTable">
      <h2>{title}</h2>
      <p>Minimal data table content.</p>
      {/* Add a simple table structure if needed for styling */}
      <table>
         <thead><tr><th>Header</th></tr></thead>
         <tbody><tr><td>Data</td></tr></tbody>
      </table>
    </div>
  );
}

export default TestComp;
